import * as THREE from 'three'

// ============================================================================
//  VerletSystem — lekki solver verleta: punkty + ograniczenia odległości.
//  Używany przez siatkę kosza, by uzyskać naturalny ruch ("swish").
// ============================================================================

export class VerletPoint {
  constructor(x, y, z, pinned = false) {
    this.pos = new THREE.Vector3(x, y, z)
    this.prev = new THREE.Vector3(x, y, z)
    this.pinned = pinned
  }
}

export class VerletSystem {
  constructor({ gravity = new THREE.Vector3(0, -6, 0), damping = 0.97, iterations = 6 } = {}) {
    this.points = []
    this.constraints = [] // { a, b, rest }
    this.gravity = gravity
    this.damping = damping
    this.iterations = iterations
    this._tmp = new THREE.Vector3()
  }

  addPoint(x, y, z, pinned = false) {
    const p = new VerletPoint(x, y, z, pinned)
    this.points.push(p)
    return this.points.length - 1
  }

  addConstraint(a, b) {
    const rest = this.points[a].pos.distanceTo(this.points[b].pos)
    this.constraints.push({ a, b, rest })
  }

  // Nadanie prędkości punktowi (przesunięcie pozycji bez prev = impuls).
  addImpulse(index, vec) {
    if (!this.points[index].pinned) this.points[index].pos.add(vec)
  }

  step(dt) {
    const d2 = dt * dt
    // integracja
    for (const p of this.points) {
      if (p.pinned) continue
      this._tmp.copy(p.pos)
      // pos += (pos - prev) * damping + g * dt^2
      p.pos.x += (p.pos.x - p.prev.x) * this.damping + this.gravity.x * d2
      p.pos.y += (p.pos.y - p.prev.y) * this.damping + this.gravity.y * d2
      p.pos.z += (p.pos.z - p.prev.z) * this.damping + this.gravity.z * d2
      p.prev.copy(this._tmp)
    }
    // ograniczenia
    for (let it = 0; it < this.iterations; it++) {
      for (const c of this.constraints) {
        const pa = this.points[c.a]
        const pb = this.points[c.b]
        const dx = pb.pos.x - pa.pos.x
        const dy = pb.pos.y - pa.pos.y
        const dz = pb.pos.z - pa.pos.z
        const dist = Math.hypot(dx, dy, dz) || 1e-6
        const diff = (dist - c.rest) / dist
        const ka = pa.pinned ? 0 : pb.pinned ? 1 : 0.5
        const kb = pb.pinned ? 0 : pa.pinned ? 1 : 0.5
        pa.pos.x += dx * diff * ka
        pa.pos.y += dy * diff * ka
        pa.pos.z += dz * diff * ka
        pb.pos.x -= dx * diff * kb
        pb.pos.y -= dy * diff * kb
        pb.pos.z -= dz * diff * kb
      }
    }
  }
}
